const IconEmail = ({ className }) => {
    return (
        <svg
            width='21'
            height='17'
            viewBox='0 0 21 17'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M2.21063 3.31424L10.1201 8.58722L18.0296 3.31424C17.8625 2.99279 17.5265 2.77323 17.1392 2.77323H3.10097C2.71368 2.77323 2.37767 2.99279 2.21063 3.31424ZM18.142 5.64958L10.6763 10.6267C10.3395 10.8512 9.9007 10.8512 9.56388 10.6267L2.09824 5.64958V13.8033C2.09824 14.3571 2.54718 14.806 3.10097 14.806H17.1392C17.693 14.806 18.142 14.3571 18.142 13.8033V5.64958ZM0.0927734 3.77596C0.0927734 2.11458 1.43959 0.767761 3.10097 0.767761H17.1392C18.8006 0.767761 20.1474 2.11458 20.1474 3.77596V13.8033C20.1474 15.4647 18.8006 16.8115 17.1392 16.8115H3.10097C1.43959 16.8115 0.0927734 15.4647 0.0927734 13.8033V3.77596Z'
            />
        </svg>
    );
};

export default IconEmail;
